import { render, staticRenderFns } from "./Seo.vue?vue&type=template&id=3cdbcbb0&scoped=true&"
import script from "./Seo.vue?vue&type=script&lang=js&"
export * from "./Seo.vue?vue&type=script&lang=js&"
import style0 from "./Seo.vue?vue&type=style&index=0&id=3cdbcbb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdbcbb0",
  null
  
)

export default component.exports